import request from '@/utils/request';

export function getRankingIndex() {
  return request({
    url: '/Ranking/index',
  });
}

export function getRankingList(params) {
  return request({
    url: '/Ranking/explore',
    params,
    silentRequest: true,
  });
}
